import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { getProviderIcon } from '@/helpers/cdn';
import { getProvidersDataByLocale, WHITE_PROVIDERS_ICONS } from './helpers';

import { ScProviders } from './styled';

type TProviders = {
  name: string;
};

interface IProvidersProps {
  items?: TProviders[];
}

export const Providers = memo(({ items }: IProvidersProps) => {
  const {
    i18n: { language },
  } = useTranslation();

  const { providers: defaultProvidersByLocale } =
    getProvidersDataByLocale(language);

  const values = useMemo(
    () => items ?? defaultProvidersByLocale,
    [items, defaultProvidersByLocale]
  );

  return (
    <ScProviders>
      {values.map((value) => (
        <div className="providers-wrapper" key={value.name}>
          <ImageComponent
            alt={value.name}
            className="provider-img"
            height={40}
            src={getProviderIcon(
              value.name,
              WHITE_PROVIDERS_ICONS.includes(value.name) ? 'white' : 'color',
              'small'
            )}
            width={40}
          />
          <div className="provider-name">{value.name}</div>
        </div>
      ))}
    </ScProviders>
  );
});
